import React from 'react';
import { FormattedPlural, IntlProvider } from 'react-intl';
import Alert from '@material-ui/core/Alert';
import useCountDown from '../../../hooks/useCountDown';
import { formatTime } from '../../../utils/date-time';
var END_TIME = 0;
var TIMEOUT_EQUATION = 48 * 60 * 60 * 1000;

var ProPromoBanner = function ProPromoBanner(_ref) {
  var isLogin = _ref.isLogin,
      user = _ref.user,
      intl = _ref.intl,
      currentRoute = _ref.currentRoute,
      onClickBanner = _ref.onClickBanner,
      currentLanguage = _ref.currentLanguage,
      accountCreatedDate = _ref.accountCreatedDate;

  var _a; // Get promo banner countdown end time


  var time = accountCreatedDate && useCountDown(accountCreatedDate);

  var _ref2 = time || {},
      _ref2$hours = _ref2.hours,
      hours = _ref2$hours === void 0 ? END_TIME : _ref2$hours,
      _ref2$minutes = _ref2.minutes,
      minutes = _ref2$minutes === void 0 ? END_TIME : _ref2$minutes,
      _ref2$diffInSeconds = _ref2.diffInSeconds,
      diffInSeconds = _ref2$diffInSeconds === void 0 ? END_TIME : _ref2$diffInSeconds;

  var _formatTime = formatTime(diffInSeconds),
      newHours = _formatTime.hours,
      newMinutes = _formatTime.minutes;

  var isPromoEnded = hours === END_TIME && minutes === END_TIME; // Set the end date and time 48 hours from now)

  var endDate = accountCreatedDate && new Date(accountCreatedDate).getTime() + TIMEOUT_EQUATION; // Dismiss promo banner after 48 hours based on account created time for new users

  var isBannerVisible = isLogin && new Date(endDate) > new Date() && !currentRoute.includes('/user/checkout') && ['free', 'basic'].includes((_a = user === null || user === void 0 ? void 0 : user.subscription) === null || _a === void 0 ? void 0 : _a.sub_category) && !isPromoEnded; // Disabled "and" when hour/minute is 0; When the langugae doesn't have "and" in the time format

  var hasAndLabel = newHours !== END_TIME && newMinutes !== END_TIME && !['cn', 'tw', 'id', 'jp', 'kr', 'ru', 'tr'].includes(currentLanguage);
  return React.createElement(React.Fragment, null, isBannerVisible && React.createElement(Alert, {
    style: {
      cursor: 'pointer'
    },
    severity: 'warning',
    onClick: onClickBanner
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'annual_plan_discount',
    defaultMessage: 'Save 20% EXTRA for annual plan:'
  }), ' ', React.createElement("b", null, "DS48AN20"), ".", ' ', intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'offer_expiry',
    defaultMessage: 'Limited time offer expires in'
  }), ' ', React.createElement("b", null, React.createElement(IntlProvider, {
    locale: currentLanguage
  }, React.createElement(React.Fragment, null, newHours !== END_TIME && React.createElement(React.Fragment, null, React.createElement("span", null, newHours), ' ', React.createElement(FormattedPlural, {
    value: newHours,
    one: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'hour',
      defaultMessage: 'hour'
    }),
    other: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'hours',
      defaultMessage: 'hours'
    })
  })), hasAndLabel && React.createElement("span", {
    style: {
      marginLeft: '0.25rem',
      marginRight: '0.25rem'
    }
  }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
    id: 'and',
    defaultMessage: 'and'
  })), newMinutes !== END_TIME && React.createElement(React.Fragment, null, React.createElement("span", null, newMinutes), ' ', React.createElement(FormattedPlural, {
    value: newMinutes,
    one: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'minute',
      defaultMessage: 'minute'
    }),
    other: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'minutes',
      defaultMessage: 'minutes'
    })
  })))))));
};

export default ProPromoBanner;